module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-view-container"
  }, _vm._l((Array.from(_vm.visitedViews)), function(tag) {
    return _c('router-link', {
      key: tag.path,
      staticClass: "tabs-view",
      attrs: {
        "to": tag.path
      }
    }, [_c('el-tag', {
      attrs: {
        "closable": true,
        "type": _vm.isActive(tag.path) ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          return _vm.closeViewTabs(tag, $event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6411016"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/TabsView.vue
// module id = 544
// module chunks = 313